import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import Modal from '../Modal';
import './style.css';

interface CancelAppointmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  appointmentDetails: {
    serviceName: string;
    masterName: string;
    date: string;
    time: string;
  };
}

const CancelAppointmentModal: React.FC<CancelAppointmentModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  appointmentDetails
}) => {
  const { language } = useLanguage();

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString(language === 'ua' ? 'uk-UA' : 'en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="cancel-appointment-modal">
        <div className="cancel-appointment-header">
          <div className="cancel-appointment-icon">
            <i className="bi bi-x-circle"></i>
          </div>
          <h2>
            {language === 'ua' ? 'Скасувати запис?' : 'Cancel Appointment?'}
          </h2>
        </div>

        <div className="cancel-appointment-content">
          <p className="cancel-appointment-message">
            {language === 'ua' 
              ? 'Ви впевнені, що хочете скасувати цей запис?'
              : 'Are you sure you want to cancel this appointment?'
            }
          </p>

          <div className="appointment-details-summary">
            <div className="detail-item">
              <span>{appointmentDetails.serviceName}</span>
            </div>
            <div className="detail-item">
              <i className="bi bi-person"></i>
              <span>{appointmentDetails.masterName}</span>
            </div>
            <div className="detail-item">
              <i className="bi bi-calendar"></i>
              <span>{formatDate(appointmentDetails.date)} о {appointmentDetails.time}</span>
            </div>
          </div>

          <p className="cancel-appointment-warning">
            {language === 'ua' 
              ? '⚠️ Пам\'ятайте, що скасування запису менш ніж за 3 години до візиту може бути обмежено.'
              : '⚠️ Remember that canceling less than 3 hours before the appointment may be restricted.'
            }
          </p>
        </div>

        <div className="cancel-appointment-actions">
          <button 
            className="cancel-appointment-btn secondary"
            onClick={onClose}
          >
            {language === 'ua' ? 'Ні, залишити' : 'No, Keep It'}
          </button>
          <button 
            className="cancel-appointment-btn danger"
            onClick={onConfirm}
          >
            {language === 'ua' ? 'Так, скасувати' : 'Yes, Cancel'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelAppointmentModal;
